module.exports = __webpack_public_path__ + "static/media/chopchop.49c3ef46.jpg";